module.exports = require("@embedpdf/core/react");